module.exports = __webpack_public_path__ + "static/7-d6c1cf846a97ac75205f9623d3003d2c.jpg";